import * as React from "react";
import * as ReactDOM from "react-dom/client";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Loading } from "./components/Common";
import { MainLayout } from "./components/layouts";
import { SecurityProvider } from "./components/security/Security";
import { routeIterator } from "./fwptools";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

const Application = () => {
    const children = [];

    routeIterator((config) => {
        if (config.isRoute()) {
            children.push(createRoute(config));
        }
    });

    return (
        <RouterProvider fallback={<Loading />} router={createBrowserRouter([
            {
                element: <SecurityProvider/>,
                children: [
                    {
                        element: <MainLayout/>,
                        children: children
                    }
                ]
            }
        ])}/>
    );
};

const createRoute = (config, user) => {
    return {
        path: config.getLink(),
        async lazy() {
            const { routeConfig } = await import(`./pages/${config.getComponent()}`);
            return routeConfig(user);
        }
    };
};

root.render(<Application />);